import React from "react";
import { Form, Input, Radio, Alert } from 'antd';
import NHSelect from '../common/NHSelect';
import NHFormItem from '../common/NHFormItem';
import NHSelector from '../common/NHSelector';
import NHFetch from '../../utils/NHFetch';
import NHMultiSelect from '../common/NHMultiSelect'
import PropTypes from 'prop-types';

const FormItem = Form.Item;
const RadioGroup = Radio.Group;
const TextArea = Input.TextArea;

const basicUrl = "/newStudent"; //基础路径

/**
 * 新生管理编辑表单
 * @author Xiafanglin
 * @date 2018-03-07 09:29:32
 * Version: 1.0
 */
class EditInitForm extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            cqfs: 1, //1：选择范围抽取；2：指定学生抽取
            dqnd: '', //当前年度
            xyxxData: [], //学院下拉数据
            zyxxData: [], //专业下拉数据
            bjxxData: [], //班级下拉数据
            xsxmArray: [], //已选择的学生姓名
            xsidArray: [], //已选择的学生ID
        }
    }

    componentDidMount() {
        this.getDqnd();
        this.getXyxxData();
    }

    //获取当前年度
    getDqnd = () => {
        NHFetch(basicUrl + '/getDqnd', 'GET')
            .then(res => {
                if (res && res.data != null) {
                    const { setFieldsValue } = this.props.form;
                    setFieldsValue({ dqnd: res.data, rxnf: res.data });

                    this.setState({ dqnd: res.data }, () => {
                        //this.props.initFunc({});
                    });
                }
            });
    }

    //加载学院数据
    getXyxxData = () => {
        NHFetch(basicUrl + '/getSelectOptionDataByFilter', 'GET', { tag: 'xy', filter: '' })
            .then(res => {
                if (res) {
                    this.setState({ xyxxData: res.data ? res.data : [] });
                }
            });
    }

    //部门信息选择回调
    handleXyxxChange = (value) => {
        const { getFieldValue, setFieldsValue } = this.props.form;
        if (value && value.length > 0) {

            NHFetch(basicUrl + '/getSelectOptionDataByFilter', 'GET', { tag: 'zy', filter: value.toString() })
                .then(res => {
                    if (res) {
                        let zyids = getFieldValue('zyids');
                        if (zyids && res.data && zyids.length > 0) {
                            let newData = res.data.map(item => item.VALUE);
                            newData = new Set(newData);
                            let newZyids = zyids.filter(item => newData.has(item));
                            setFieldsValue({ zyids: newZyids });
                            this.handleZyxxChange(newZyids);
                        }
                        this.setState({ zyxxData: res.data ? res.data : [] });
                    }
                })

        } else {
            setFieldsValue({ zyids: [], bjids: [] });
            this.setState({ zyxxData: [], bjxxData: [] });
        }

    }

    //专业信息选择回调
    handleZyxxChange = (value) => {
        const { getFieldValue, setFieldsValue } = this.props.form;
        if (value && value.length > 0) {

            NHFetch(basicUrl + '/getSelectOptionDataByFilter', 'GET', { tag: 'bj', filter: value.toString() })
                .then(res => {
                    if (res) {
                        let bjids = getFieldValue('bjids');
                        if (bjids && res.data && bjids.length > 0) {
                            let newData = res.data.map(item => item.VALUE);
                            newData = new Set(newData);
                            let newBjids = bjids.filter(item => newData.has(item));
                            setFieldsValue({ bjids: newBjids });
                        }
                        this.setState({ bjxxData: res.data ? res.data : [] });
                    }
                })

        } else {
            setFieldsValue({ bjids: [] });
            this.setState({ bjxxData: [] });
        }
    }

    //抽取方式变化回调
    handleRadioChange = (e) => {
        this.setState({ cqfs: e.target.value });
        //如果是选择范围抽取，则重置已选择的学生
        if (e.target.value == 1) {
            const { setFieldsValue } = this.props.form;
            setFieldsValue({ 'xsmcs': '', 'xsids': [] });
            this.setState({ xsxmArray: [], xsidArray: [] });
        }
    }

    //显示学生选择器
    showStudentsSelector = () => {
        this.nhStudentSelector.show();
    }

    //学生选择器选择确认回调
    handleStudentsSelectorOk = (selectObject) => {
        const { setFieldsValue } = this.props.form;
        let { selectedNames, selectedKeys } = selectObject;
        let { xsxmArray = [], xsidArray = [] } = this.state;

        const xsxmSet = new Set(xsxmArray);
        const xsidSet = new Set(xsidArray);

        if (selectedNames && selectedNames.length > 0) {
            for (let key in selectedNames) {
                xsxmSet.add(selectedNames[key]);
            }
        }

        if (selectedKeys && selectedKeys.length > 0) {
            for (let key in selectedKeys) {
                xsidSet.add(selectedKeys[key]);
            }
        }

        this.setState({ xsxmArray: Array.from(xsxmSet), xsidArray: Array.from(xsidSet) });
        setFieldsValue({ 'xsmcs': Array.from(xsxmSet).join('，'), 'xsids': Array.from(xsidSet) });
    }

    render() {

        //Alert提示布局
        const formItemLayout = {
            wrapperCol: {
                xs: { span: 24, offset: 0 },
                sm: { span: 12, offset: 6 },
                md: { span: 10, offset: 7 }
            }
        };

        const { form, availableStudentNumber, disabledStudentNumber } = this.props;
        const { cqfs, dqnd, xyxxData, zyxxData, bjxxData } = this.state;

        let message = (
            <span>
                本范围已经被抽取了
                <span style={{ fontWeight: 'bold' }}> {disabledStudentNumber} </span>人，还能够抽取
                <span style={{ fontWeight: 'bold' }}> {availableStudentNumber} </span>人
            </span>
        );

        return (
            <div>
                <Form layout="horizontal">
                    <div style={{ display: "none" }} >
                        <NHFormItem id={"xsids"} form={form} >
                            <Input />
                        </NHFormItem>
                        <NHFormItem id={"dqnd"} form={form} initialValue={dqnd}>
                            <Input />
                        </NHFormItem>
                    </div>
                    <NHFormItem id={"cqfs"} label="抽取方式" form={form} initialValue={cqfs}>
                        <RadioGroup onChange={this.handleRadioChange} >
                            <Radio value={1}>指定范围</Radio>
                            <Radio value={2}>指定学生</Radio>
                        </RadioGroup>
                    </NHFormItem>
                    <div style={{ display: cqfs == 1 ? "block" : "none" }} >
                        <NHFormItem id={'rxnf'} label={'入学年份'} form={form} initialValue={dqnd} >
                            <NHSelect sign={"zhxg_year"} />
                        </NHFormItem>
                        <NHFormItem id={'xslbm'} label={'学生类别'} form={form}>
                            <NHSelect sign={"DMK_XTGL_XSLBM"} />
                        </NHFormItem>
                        <NHFormItem id={'bmids'} label={'所属院系'} form={form}>
                            <NHMultiSelect dataSource={xyxxData} disabled={cqfs == 1 ? false : true} onChange={this.handleXyxxChange} />
                        </NHFormItem>
                        <NHFormItem id={'zyids'} label={'所属专业'} form={form}>
                            <NHMultiSelect dataSource={zyxxData} disabled={cqfs == 1 ? false : true} onChange={this.handleZyxxChange} />
                        </NHFormItem>
                        <NHFormItem id={'bjids'} label={'所属班级'} form={form}>
                            <NHMultiSelect dataSource={bjxxData} disabled={cqfs == 1 ? false : true} />
                        </NHFormItem>
                    </div>
                    <div style={{ display: cqfs == 1 ? "none" : "block" }} >
                        <NHFormItem id={"xsmcs"} label={"选择学生"} form={form}>
                            <TextArea autosize={{ minRows: 3, maxRows: 6 }} onClick={this.showStudentsSelector} />
                        </NHFormItem>
                    </div>
                    <div style={{ display: cqfs == 1 ? 'block' : 'none' }}>
                        <FormItem {...formItemLayout}>
                            <Alert showIcon message={message} />
                        </FormItem>
                    </div>
                </Form>
                <NHSelector
                    ref={(ref) => { this.nhStudentSelector = ref }}
                    title={'请选择需要迎新的学生'}
                    //treeCheckable={true}
                    treeSearch={true}
                    width={1002}
                    sign={"zhxg_yxxs_selector_modal"}
                    onOk={this.handleStudentsSelectorOk} />
            </div>
        );
    }
}

//默认属性
EditInitForm.defaultProps = {
    availableStudentNumber: 0, //范围内已抽取的学生人数
    disabledStudentNumber: 0, //范围内可以抽取的学生人数
}

//属性检查
EditInitForm.propTypes = {
    disabledStudentNumber: PropTypes.number, //范围内已抽取的学生人数
    availableStudentNumber: PropTypes.number, //范围内可以抽取的学生人数
    initFunc: PropTypes.func, //初始化
    onChange: PropTypes.func, //表单项值变化回调
}

const EditForm = Form.create({ onValuesChange(props, values) { props.onChange(values); } })(EditInitForm);

export default EditForm;


// WEBPACK FOOTER //
// ./components/newStudentMng/EditForm.js